// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

// const firebaseConfig = {
//   apiKey: "AIzaSyC8KwQ5SfIjWaB3ZdYaV70Oh5QHmwUb2Vg",
//   authDomain: "alyana-app.firebaseapp.com",
//   projectId: "alyana-app",
//   storageBucket: "alyana-app.appspot.com",
//   messagingSenderId: "544685788329",
//   appId: "1:544685788329:web:9e5774d2180529db4f6db8",
//   measurementId: "G-3GQZTVEWW1",
// };
// const firebaseConfig = {
//   apiKey: "AIzaSyAokJk9lGSaNDFEvkRfjCeU98Q3OevKlz4",
//   authDomain: "healthbox-61f27.firebaseapp.com",
//   projectId: "healthbox-61f27",
//   storageBucket: "healthbox-61f27.appspot.com",
//   messagingSenderId: "551412109546",
//   appId: "1:551412109546:web:0f197696eecc8060c8c793",
//   measurementId: "G-238W5ET316"
// }

const firebaseConfig = {
  apiKey: "AIzaSyAxf0cUgXphaMK33HEtaGia0ZgVIaw7qco",
  authDomain: "reyna-care-aa191.firebaseapp.com",
  projectId: "reyna-care-aa191",
  storageBucket: "reyna-care-aa191.firebasestorage.app",
  messagingSenderId: "797055590014",
  appId: "1:797055590014:web:eb7d6ae617cb80a49fc22f",
  measurementId: "G-MY1BSN8PNE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BBr73ulxqTwAoEx_cTjtQJ682zL5NR57HMmvTe-NnB05JC8L_1fuMxu02tvmjUXclwKnU4pdY4zupHBECfXPagU",
      // vapidKey:"BG0qZGF7_VpWsBoLd3y1m3yrA82xy8GyqzuZTKzR6UVn5vD3Q35-ZUnu_WVXHU-iQ0jQhN_qBR3osawrSWdsUl8"
      // "BBseKFBkK-7eAIvQxtswFkW0lD2x0U20RwCbvH79OVzddZ5vp6O-3a5ew_VN-zi6x6GSWQtjqnLJRy_D0Ct9r9Q",
    });
    localStorage.setItem("FCM_TOKEN", token);
  }
};
